import { Controller } from "@hotwired/stimulus"

// One survey question (user survey plan R9, R11, KTD8). On a pick-up-to-N
// question, ticking the Nth box dims the rest until one is unticked; the
// server keeps only the first N anyway, this just says so before the post.
// Typing in a write-in ticks the option that opens it, so the words are
// never lost to an unticked "Other", including once a full question frees a
// slot.
export default class extends Controller {
  static targets = ["box", "note", "writeInBox", "writeInText"]
  static values = { cap: Number }

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.capValue) return

    const ticked = this.boxTargets.filter((box) => box.checked).length
    const full = ticked >= this.capValue
    const writeInWasClosed = this.hasWriteInBoxTarget && this.writeInBoxTarget.disabled
    this.boxTargets.forEach((box) => {
      if (!box.checked) box.disabled = full
    })
    if (this.hasNoteTarget) this.noteTarget.hidden = !full
    // A slot just freed up while words already sit in the write-in.
    if (writeInWasClosed && !this.writeInBoxTarget.disabled) this.writeIn()
  }

  writeIn() {
    if (!this.hasWriteInBoxTarget || !this.hasWriteInTextTarget || this.writeInBoxTarget.disabled) return
    if (this.writeInTextTarget.value.trim() === "" || this.writeInBoxTarget.checked) return
    // On a one-choice question the write-in explains its own option (Q4's
    // "No, because…"); it never overrides an answer already picked.
    if (this.writeInBoxTarget.type === "radio" && this.element.querySelector("input[type=radio]:checked")) return

    this.writeInBoxTarget.checked = true
    this.refresh()
  }
}
